import findResult, { findWithCodes } from '@/utils/resultsHelper';
import { dictionaryMarkdownCategories } from '../constants';

const initialState = {
  markdowns: {
    open: {
      results: [],
    },
  },
};

export const findDictionaryMarkdown = ({ markdowns }, { category, code }) => (
  findResult(markdowns, category, code)
);

export const findAllDictionaryMarkdowns = ({ markdowns }, { items }, attribute = 'code') => {
  const codes = items.map(({ code }) => code);
  return findWithCodes(markdowns, dictionaryMarkdownCategories, codes, attribute);
};

export default initialState;
